"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialogActions = exports.contentRoot = exports.closeIcon = exports.title = exports.dialogTitle = void 0;

var _react = require("@emotion/react");

var _utils = require("../../../utils");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-top: ", ";\n  & > .MuiDialogActions-spacing:not(:first-child) {\n    margin-left: 12px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var dialogTitle = function dialogTitle(theme) {
  return (0, _react.css)((0, _utils.mq)(theme)({
    textAlign: 'left',
    padding: ['24px 16px 0px', '32px 32px 0px']
  }));
};

exports.dialogTitle = dialogTitle;

var title = function title(theme) {
  return (0, _react.css)((0, _utils.mq)(theme)({
    margin: 0,
    maxWidth: 'calc(100% - 32px)',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }));
};

exports.title = title;

var closeIcon = function closeIcon(theme) {
  return (0, _react.css)((0, _utils.mq)(theme)({
    width: 24,
    height: 24,
    cursor: 'pointer',
    position: 'absolute',
    right: [16, 32]
  }));
};

exports.closeIcon = closeIcon;

var contentRoot = function contentRoot(theme) {
  return (0, _react.css)((0, _utils.mq)(theme)({
    '&:first-of-type': {
      paddingTop: 0,
      overflow: 'auto'
    }
  }));
};

exports.contentRoot = contentRoot;

var dialogActions = function dialogActions(scrollable) {
  return function (theme) {
    return (0, _react.css)(_templateObject(), scrollable ? "1px solid ".concat(theme.colors.neutral[200]) : 'unset');
  };
};

exports.dialogActions = dialogActions;